module.exports = __webpack_public_path__ + "static/becky-cf088e44d7abec4a0cf49dfeb5b5d083.jpg";